import { Col, Table } from "antd";
import { isArray } from "lodash";

export default function ExpectedBreakdown({ obShowData }) {
  
  const considerableDays = obShowData?.created_for == 'OB' 
    ? obShowData?.considerable_days || 0 
    : obShowData?.initial_sam_info?.considerable_days || 0;

  const shouldUseTotalDayLists = considerableDays > 0;
  const tableDataSource = shouldUseTotalDayLists
    ? obShowData?.summary?.totalDayLists
    : obShowData?.summary?.learning_curve_info?.curve_details;
    
  return (
    <>
      <Col span={12} className="mb-4">
        <Table
          size="small"
          dataSource={tableDataSource}
          bordered
          pagination={false}
          columns={[
            {
              title: "Day",
              dataIndex: "day",
              key: "day",
            },
            {
              title: "Efficiency",
              dataIndex: "efficiency",
              key: "day",
            },
            {
              title: "W. Hours	",
              dataIndex: "working_hours",
              key: "working_hours",
            },
            {
              title: "Apx. MP	",
              dataIndex: "approx_manpower",
              key: "approx_manpower",
            },
            {
              title: "Day Qty",
              dataIndex: "dayQty",
              key: "dayQty",
            },
          ]}
          summary={
            shouldUseTotalDayLists 
            ? undefined 
            : () => {
            const additional_days =
              isArray(obShowData?.summary?.additional_days) &&
              obShowData?.summary?.additional_days.length > 0
                ? obShowData?.summary?.additional_days
                : [];
            return (
              <Table.Summary>
                {additional_days.length > 0 && (
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0} colSpan={5}>
                      <strong>...</strong>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                )}

                {additional_days.length > 0
                  ? [additional_days[additional_days.length - 1]].map(
                      (item, index) => (
                        <Table.Summary.Row key={index}>
                          <Table.Summary.Cell index={0} colSpan={1}>
                            <strong>{item.day}</strong>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={1} colSpan={1}>
                            {item.efficiency}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={1} colSpan={1}>
                            {item.working_hours}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={1} colSpan={1}>
                            {item.approx_manpower}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={1} colSpan={1}>
                            {item.dayQty}
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      ),
                    )
                  : null}
              </Table.Summary>
            );
          }
          }
        />
      </Col>
      <Col span={12} style={{ marginBottom: 10 }}>
        <Table
          size="small"
          dataSource={[
            {
              name: "Order Quantity",
              value:
                obShowData?.summary?.expected_production_breakdown
                  ?.order_quantity || 0,
            },
            {
              name: "Learning Curve Qty",
              value:
                obShowData?.summary?.expected_production_breakdown
                  ?.learning_curve_quantity || 0,
            },
            {
              name: "Remaining Qty",
              value:
                obShowData?.summary?.expected_production_breakdown
                  ?.remaining_quantity || 0,
            },
            {
              name: "Learning Curve Days",
              value:
                obShowData?.summary?.expected_production_breakdown
                  ?.learning_curve_days || 0,
            },
            {
              name: "Remaining Days for Remaining Qty",
              value:
                obShowData?.summary?.expected_production_breakdown
                  ?.remaining_days_for_remaining_qty || 0,
            },
            {
              name: "Total Required Days",
              value: isNaN(
                parseFloat(
                  obShowData?.summary?.expected_production_breakdown
                    ?.total_required_days.toFixed(2),
                ).toFixed(2),
              )
                ? 0
                : parseFloat(
                    obShowData?.summary?.expected_production_breakdown
                      ?.total_required_days.toFixed(2),
                  ).toFixed(2),
            },
            {
              name: "Learning Curve (hr)",
              value:
                obShowData?.summary?.expected_production_breakdown
                  ?.learning_curve_hour.toFixed(2) || 0,
            },
            {
              name: "Remaining (hr)",
              value: isNaN(
                parseFloat(
                  obShowData?.summary?.expected_production_breakdown
                    ?.remaining_hour,
                ).toFixed(2),
              )
                ? 0
                : parseFloat(
                    obShowData?.summary?.expected_production_breakdown
                      ?.remaining_hour,
                  ).toFixed(2),
            },
            {
              name: "Total (hr)",
              value: isNaN(
                parseFloat(
                  obShowData?.summary?.expected_production_breakdown
                    ?.total_hour,
                ).toFixed(2),
              )
                ? 0
                : parseFloat(
                    obShowData?.summary?.expected_production_breakdown
                      ?.total_hour,
                  ).toFixed(2),
            },
          ]}
          bordered
          columns={[
            {
              title: "Name",
              dataIndex: "name",
              key: "name",
              render: (text) => (
                <strong style={{ textTransform: "capitalize" }}>{text}</strong>
              ),
            },
            {
              title: "Value",
              dataIndex: "value",
              key: "value",
              align: "right",
            },
          ]}
          pagination={false}
        />
      </Col>
    </>
  );
}
